<template>
    <header
            :class="{'coach-home-header': mode === 'full'}"
    >
        <div class="row coach-home-header-row">
            <div class="col coach-home-header-col">
                <a href="#">
                    <b-card class="coach-home-header-card">
                        <h2>
                            <i class="fas fa-users"></i>
                            <br class="d-xl-none">
                            Participation
                        </h2>
                        <div class="coach-home-header-card-content">
                            <span>{{indicators.attendance}}%</span>
                            <div class="coach-home-header-gauge">
                                <div
                                        class="coach-home-header-gauge-filling"
                                        :style="`width: ${indicators.attendance}%`"
                                >
                                </div>
                            </div>
                        </div>
                        <b-button
                                class="coach-home-info-modal-btn"
                                @click="infoModalParticipation = !infoModalParticipation"
                        >
                            <i class="fas fa-info-circle"></i>
                        </b-button>
                        <b-modal
                                v-model="infoModalParticipation"
                                body-class="info-modal"
                                ok-only
                                centered
                                scrollable
                                hide-header
                                hide-footer
                        >
                            <h1>
                                <i class="fas fa-users"></i>
                                Participation
                            </h1>

                            <p> Le niveau de participation est calculé en fonction de la participation moyenne des salariés aux séances de leurs équipes.
                                Cela inclut la participation aux séances d’échauffement et d’étirements.
                            </p>

                            <div class="info-modal-button">
                                <b-button
                                        class="modal-btn"
                                        @click="infoModalParticipation = !infoModalParticipation"
                                >
                                    Ok
                                </b-button>
                            </div>
                        </b-modal>
                    </b-card>
                </a>
            </div>
            <div class="col coach-home-header-col">
                <a href="#">
                    <b-card class="coach-home-header-card">
                        <h2>
                            <i class="far fa-smile"></i>
                            <br class="d-xl-none">
                            Satisfaction
                        </h2>
                        <div class="coach-home-header-card-content">
                            <div class="coach-home-header-stars">
                                <template v-for="i in 5">
                                    <i
                                            class="fa-star"
                                            :class="i <= indicators.mark ? 'fas':'far'"
                                    />
                                </template>
                            </div>
                        </div>
                        <b-button
                                class="coach-home-info-modal-btn"
                                @click="infoModalSatisfaction = !infoModalSatisfaction"
                        >
                            <i class="fas fa-info-circle"></i>
                        </b-button>
                        <b-modal
                                v-model="infoModalSatisfaction"
                                body-class="info-modal"
                                ok-only
                                centered
                                scrollable
                                hide-header
                                hide-footer
                        >
                            <h1>
                                <i class="far fa-smile"></i>
                                Satisfaction
                            </h1>
                            <p>
                                Le niveau de satisfaction est calculé en fonction de la notation des séances.
                                Les notations des séances ne prennent pas compte de l’environnement de travail,
                                mais uniquement du déroulement de la séance (exercices, animation par le coach,
                                efficacité ressentie).
                            </p>

                            <div class="info-modal-button">
                                <b-button
                                        class="modal-btn"
                                        @click="infoModalSatisfaction = !infoModalSatisfaction"
                                >
                                    Ok
                                </b-button>
                            </div>
                        </b-modal>
                    </b-card>
                </a>
            </div>
            <div class="col coach-home-header-col">
                <a href="#">
                    <b-card class="coach-home-header-card">
                        <h2>
                            <i class="fas fa-clipboard-list"></i>
                            <br>
                            Suivis
                        </h2>
                        <div class="coach-home-header-card-content">
                            <span>{{indicators.traces}}%</span>
                            <div class="coach-home-header-gauge">
                                <div
                                        class="coach-home-header-gauge-filling"
                                        :style="`width: ${indicators.traces}%`"
                                >
                                </div>
                            </div>
                        </div>
                        <b-button
                                class="coach-home-info-modal-btn"
                                @click="infoModalSuivis = !infoModalSuivis"
                        >
                            <i class="fas fa-info-circle"></i>
                        </b-button>
                        <b-modal
                                v-model="infoModalSuivis"
                                body-class="info-modal"
                                ok-only
                                centered
                                scrollable
                                hide-header
                                hide-footer
                        >
                            <h1>
                                <i class="fas fa-clipboard-list"></i>
                                Suivis
                            </h1>

                            <p>
                                Le niveau de suivi est calculé en fonction du reporting des séances en temps réel.
                                Cela correspond à la saisie des feuilles de présence,
                                à la notation de la séance par le coach et à la remontée éventuelle
                                d’informations spécifiques à la séance (prise en main des relais,
                                changement d’exercice, événements inattendus…).
                            </p>

                            <div class="info-modal-button">
                                <b-button
                                        class="modal-btn"
                                        @click="infoModalSuivis = !infoModalSuivis"
                                >
                                    Ok
                                </b-button>
                            </div>
                        </b-modal>
                    </b-card>
                </a>
            </div>
        </div>
    </header>
</template>

<style lang="scss" scoped>
    @media screen and (min-width: 1500px){
        .coach-home-header-card{
            br{
                display: none;
            }
        }

    }
</style>

<script>
    export default {
        name: 'home-top-coach',
        props: {
            indicators: Object,
            mode: {
                type: String,
                default: 'full'
            }
        },
        data: () => ({
            infoModalParticipation: false,
            infoModalSatisfaction: false,
            infoModalSuivis: false
        })
    }
</script>
